<template>
  <div>
    <div v-bind:style="'background-image: url(' + thumbnailOriginal + ')'" class="products-banner">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="white">
              {{category}}: {{product.title}}
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="processing">
      <div class="row space-loader d-flex align-items-center justify-content-center">
        <b-spinner style="width: 6rem; height: 6rem;" label="Large Spinner"></b-spinner>
      </div>
    </div>
    <div class="container section-padding" v-else>
      <div class="row">
        <div class="col-lg-12">
          <div class="float-cara">
            <flickity class="carousel-main" ref="flickity" :options="flickityOptions">
              <div v-for="(media, mediaIndex) in product.media" :key="mediaIndex"
                v-bind:style="'background-image: url(' + src(media.id) + ')'" class="flick-parent"></div>
            </flickity>
            <flickity ref="flickitynav" :options="flickitynavOptions">
              <div v-for="(media, mediaIndex) in product.media" :key="mediaIndex"
                v-bind:style="'background-image: url(' + src(media.id) + ')'" class="flick-nav"></div>
            </flickity>
          </div>
          <h2 class="space-bottom-small">{{product.title}}</h2>
          <h3 class="space-bottom">Price:<strong> {{priceString}}</strong></h3>
          <button v-if="!inCart" @click="addToCart" type="button" class="btn space-bottom">Add To Cart</button>
          <button v-else @click="removeFromCart" type="button" class="btn space-bottom">Remove From Cart</button>
          <p>
            {{product.description}}
          </p>
        </div>
      </div>
    </div>
    <div class="homepage-contact relative ">
      <div class="container homepage-contact-padding">
        <div class="row">
          <div class="col-lg-6">
            <h2 class="space-bottom white">Contact Us For More Info</h2>
            <p class="white no-bottom">
             Click the button to visit our contact page if you need to get ahold of us for more informaion.
            </p>
          </div>
          <div class="col-lg-6 d-flex align-items-center justify-content-lg-end">
            <router-link to="/contact">
              <div class="button-container ">
                <div class="standard-button d-flex flex-row">
                  <div class="cart-left d-flex align-items-center">
                    <p>Contact Us</p>
                  </div>
                  <div class="cart-right d-flex align-items-center justify-content-center">
                    <ArrowRightIcon :size="100" fillColor="rgb(255,255,255)" />
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "../../api/api";
  import Flickity from 'vue-flickity';
  import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
  import 'flickity-as-nav-for'
  export default {
    components: {
      Flickity,
      ArrowRightIcon
    },
    data: function () {
      return {
        product: {
          id: "",
          title: "",
          description: "",
          media: [],
          metadata: {},
          price: "",
          status: "",
          type: "",
        },
        flickityOptions: {
          prevNextButtons: false,
          pageDots: false,
          wrapAround: false,
          draggable: false,
        },
        flickitynavOptions: {
          pageDots: false,
          draggable: false,
          asNavFor: '.carousel-main',
          cellAlign: 'left',
          contain: true
        },
        processing: false,
        category: ""
      };
    },

    mounted() {
      this.loadProduct();
    },
    watch: {
      $route() {
        this.loadProducts();
      },
    },
    computed: {
      priceString() {
        return this.product.price.toLocaleString(undefined, {
          style: "currency",
          currency: "USD",
        });
      },
      thumbnailOriginal() {
        var id = "";
        if (typeof this.product.metadata.thumbnail != "undefined") {
          id = this.product.metadata.thumbnail;
        } else if (this.product.media.length != 0) {
          id = this.media[0].id;
        }
        if (id == "") return "";
        return process.env.VUE_APP_API_URL + `/media/${id}.png`;
      },
      inCart() {
        return this.product.id in this.$store.state.cart;
      },
    },
    methods: {
      fixCat() {
        switch (this.product.type) {
          case "car":
            this.category = "Cars"
            return;
          case "electronic":
            this.category = "Electronics"
            return;
          case "engine":
            this.category = "Engines"
            return;
          case "helicopter":
            this.category = "Helicopters"
            return;
          case "kit":
            this.category = "Kits"
            return;
          case "plane":
            this.category = "Planes"
            return;
          case "spare":
            this.category = "Spares"
            return;
          case "steam":
            this.category = "Steam"
            return;
          case "tool":
            this.category = "Tools"
            return;
          case "train":
            this.category = "Trains"
            return;
        }
      },
      loadProduct() {
        this.$refs.flickity.reloadCells()
        this.$refs.flickitynav.reloadCells()
        this.processing = true;
        api
          .getProduct(this.$route.params.id)
          .then((res) => {
            this.product = res;
            this.fixCat()
            this.processing = false;
          })
          .catch(() => {
            this.processing = false;
          });
      },
      addToCart() {
        this.$store.dispatch("addToCart", this.product);
      },
      removeFromCart() {
        this.$store.dispatch("removeFromCart", this.product.id);
      },
      thumb(id) {
        return process.env.VUE_APP_API_URL + `/media/thumbnails/300/${id}.png`;
      },
      src(id) {
        return process.env.VUE_APP_API_URL + `/media/${id}.png`;
      },
    },
  };
</script>